import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
import _inheritsLoose from "@babel/runtime/helpers/inheritsLoose";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Button from '../Button';
import { DropdownContainer, DropdownBackdrop, DropdownMenu } from './Dropdown.styles';
/**
 * Renders a toggleable list of items.
 *
 * @public
 * @author Connor Taylor
 */

var Dropdown =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(Dropdown, _Component);

  function Dropdown(props) {
    var _this;

    _this = _Component.call(this, props) || this;

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onClick", function (e) {
      var onClick = _this.props.onClick;

      _this.setState({
        open: !_this.state.open
      });

      if (onClick) {
        onClick(e);
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "closeMenu", function () {
      return _this.setState({
        open: false
      });
    });

    _this.state = {
      open: false
    };
    return _this;
  }

  var _proto = Dropdown.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        items = _this$props.items,
        buttonLabel = _this$props.buttonLabel,
        noBackdrop = _this$props.noBackdrop,
        className = _this$props.className,
        CustomMenu = _this$props.CustomMenu,
        rest = _objectWithoutPropertiesLoose(_this$props, ["items", "buttonLabel", "noBackdrop", "className", "CustomMenu"]);

    var backdrop = this.state.open && !noBackdrop ? React.createElement(DropdownBackdrop, {
      onClick: this.closeMenu
    }) : null;
    var CustomMenuContainer = CustomMenu || DropdownMenu;
    var menu = this.state.open ? React.createElement(CustomMenuContainer, _extends({}, rest, {
      onClick: this.closeMenu,
      open: this.state.open
    }), items) : null;
    var trigger = this.props.children ? React.cloneElement(React.Children.only(this.props.children), {
      onClick: this.onClick
    }) : React.createElement(Button, {
      onClick: this.onClick
    }, buttonLabel);
    return React.createElement(DropdownContainer, {
      className: className
    }, trigger, menu, backdrop);
  };

  return Dropdown;
}(Component);

Dropdown.defaultProps = {
  items: []
};
export default Dropdown;